import { createTextComponent } from './text.component'

/* Styles ======================================================================================= */
import { titleClass } from './title.class'

export const Title = createTextComponent(titleClass)
